
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroMediaLinksItemLinkType = typeof GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroMediaLinksItemLinkType[keyof typeof GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezeroMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
